module.exports = __webpack_public_path__ + "img/activity_other11.c26c9106.jpg";